import type { LogDto } from '../types/LogDto';
import { get as getConfig } from '../core/config';
import { addMeta } from '../core/meta';
import { noThrottle, throttle } from '../core/handle-logs';

/**
 * Sends a log to the server.
 * @param logDto
 * @param applicationUid
 */
export function log(logDto: LogDto, applicationUid: string | null = null) {
    let payload: LogDto = {
        sessionUid: getConfig('sessionUid', applicationUid),
        logTime: Date.now(),
        version: getConfig('version', applicationUid),
        ...logDto
    };

    if (payload && payload.data && typeof payload.data !== 'object') {
        console.warn('chayns-logger: data requires an object.')
    }

    const defaults = getConfig('defaults', applicationUid);
    if (payload.data || defaults) {
        payload.data = { ...defaults, ...payload.data };
    }
    payload = addMeta(payload, applicationUid);

    const middleware = getConfig('middleware', applicationUid);
    if (middleware && middleware(payload) === false) {
        return;
    }

    setTimeout(() => {
        if (getConfig('throttleTime', applicationUid)) {
            throttle([payload], applicationUid);
        } else {
            noThrottle([payload], applicationUid);
        }
    });
}
